  // DonutChart.js
  import React , { useEffect, useState } from 'react';
  import { useTranslation } from 'react-i18next';
  //import DOMPurify from 'dompurify';
  //import './DonutChart.css';
    
  export function toChartData(values, productName = "No name", colors, t, i18n) {

	if (
	  values &&
	  Array.isArray(values) &&
	  values.length > 0
	) {
	  var chartDataItemsList = processData(values, colors, t, i18n);

  	  chartDataItemsList.sort((a, b) => a.order - b.order);
	  // Construct the final chart data object
	  let chartData = {
		chartData: chartDataItemsList,
		chartTitel: productName,
		overallLabel: t('overallLabel'),
	  };
  
	  return chartData;
	}
  }

  const processData = (data, colors, t, i18n) => {
	const result = [];
	let colorIndex = 0;
  
	data.forEach((item) => {
		const colorEntry = colors[colorIndex];
		const colorClass = Object.keys(colorEntry)[0];
		const colorHex = colorEntry[colorClass];


		result.push({
			label: i18n.exists(item.label) ? t(item.label) : item.label,
			legend: true,
			allotment: item.value,
			allotmentLabel: "" + item.value,
			colorHex: colorHex,
			colorClass: colorClass,
		});
		// Increment the color index and reset if it exceeds the length of the colors array
		colorIndex = (colorIndex + 1) % colors.length;
	});
  
	return result;
  };  

  const DonutChart = ({
	  scBreakdownDataUrl,
	  breakdownTitleKey,
	  productName,
	  headline,
	  subHeadline,
	  colors,
	}) => {
	  const { t, i18n } = useTranslation();	
	  const [structureData, setStructureData] = useState(null); 
	  const [asOfDate, setAsOfDate] = useState(null); 
	
	  useEffect(() => {
		const fetchData = async () => {
		let baseUrl = process.env.REACT_APP_DATA_URL || '#{DATA_URL}';

		  const fundResponse = await fetch(`${baseUrl}${scBreakdownDataUrl}`);
	  
		  if (!fundResponse.ok) {
			throw new Error('HTTP error!');
		  }
	  
		  const fetchedFundDataArray = await fundResponse.json();
		  const fundDataObject = Array.isArray(fetchedFundDataArray) ? fetchedFundDataArray[0] : fetchedFundDataArray;

		  let structure;
		  if (fundDataObject && Array.isArray(fundDataObject.Breakdowns)) {
			structure = fundDataObject.Breakdowns.find(breakdown => breakdown.BreakdownTitleKey === breakdownTitleKey);
		  }

		  var transformedChartData = toChartData(structure?.Values, productName, colors, t, i18n);

		  setStructureData(transformedChartData);

				  setAsOfDate(fundDataObject?.BreakdownAsOfDate);

		  setTimeout(() => {
			window.applicationReInit(['Donut']);
		  }, 100);        
		};
	  
		fetchData().catch((error) => console.error(error));
  
	  }, [scBreakdownDataUrl, breakdownTitleKey, colors, productName, t, i18n]);
  
	  if (!structureData) {
		return <div>Loading...</div>;
	  }
  
	  return (
		<div className="l-grid__row justify-content-center">
			<div className="m-donut l-grid__column-large-6 l-grid__column-medium-6 u-text-align-center">
				<div className="u-margin-m donut-chart"
					data-chart={JSON.stringify(structureData)}>
						
					<div className="l-grid__row justify-content-center">
						<h2 className="c-heading u-margin-bottom-m" tabIndex="0">
							{headline}
						</h2>
					</div>
					{asOfDate && (
						<div className="l-grid__row justify-content-center">
							<p className="c-copy u-margin-bottom-2m" tabIndex="0">
								{t('asOfDateLabel')} {asOfDate}
							</p>
						</div>
					)}
					<div className="l-grid__row justify-content-center">
						<p className="c-copy u-margin-bottom-none" tabIndex="0">
							{subHeadline}
						</p>
					</div>


					<div className="l-grid__row justify-content-center">
						<div className="chart-wrapper"></div>
					</div>
					<div className="l-grid__row justify-content-center">
						<div className="donut-legends u-flex"> </div>
					</div>
				</div>
			</div>
		</div>
	  )
  }
  
  export default DonutChart;